import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Alert } from "@mui/material";
import { validateQuizJSON } from "../../utils/quizSchema";

export default function AdminEventQuizDialog({ open, onClose, eventItem, onSave }) {
  const [jsonText, setJsonText] = useState('{\n  "questions": []\n}');
  const [error, setError] = useState("");

  useEffect(() => {
    if (eventItem?.quiz) {
      try {
        setJsonText(JSON.stringify(eventItem.quiz, null, 2));
      } catch {
        setJsonText('{\n  "questions": []\n}');
      }
    } else {
      setJsonText('{\n  "questions": []\n}');
    }
    setError("");
  }, [eventItem?.id, open]);

  const handleValidate = () => {
    setError("");
    try {
      const obj = JSON.parse(jsonText);
      const r = validateQuizJSON(obj);
      if (!r.valid) {
        setError(r.error);
      }
    } catch (e) {
      setError("Invalid JSON: " + e.message);
    }
  };

  const handleSave = async () => {
    setError("");
    try {
      const obj = JSON.parse(jsonText);
      const r = validateQuizJSON(obj);
      if (!r.valid) {
        setError(r.error);
        return;
      }
      await onSave(obj);
    } catch (e) {
      setError(e.message || "Failed to save quiz");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Event Quiz Builder</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField
          label="Quiz JSON"
          value={jsonText}
          onChange={(e) => setJsonText(e.target.value)}
          multiline
          minRows={18}
          fullWidth
          placeholder='{"questions":[{"id":"q1","text":"...","options":["A","B"],"correct":0}]}'
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleValidate}>Validate</Button>
        <Button variant="contained" onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}
